// extracted by mini-css-extract-plugin
export default {"controls":"mobile-testimonials-module--controls--z48Nh","testimonialWrapper":"mobile-testimonials-module--testimonial-wrapper--I90U3"};